function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  y1: 101.59,
  x2: 769.87,
  y2: 101.59,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#202031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#25253d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#33345c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#494b8e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#5356a5"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "stock-graph"
}, /*#__PURE__*/React.createElement("polyline", {
  className: "scaleable-vector-line",
  points: "768.93 105.39 695.16 144.47 541.93 2.8 411.92 138.78 372.34 127.19 303.16 139.02 253.25 68.22 0.93 201.42",
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  stroke: "url(#linear-gradient)",
  strokeDasharray: "770px, 780px"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "stock-indicators"
}, /*#__PURE__*/React.createElement("line", {
  x1: 199.09,
  y1: 49.02,
  x2: 215.92,
  y2: 49.02,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 199.09,
  y1: 77.2,
  x2: 215.92,
  y2: 77.2,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 199.09,
  y1: 105.39,
  x2: 215.92,
  y2: 105.39,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 199.09,
  y1: 133.58,
  x2: 215.92,
  y2: 133.58,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 199.09,
  y1: 161.77,
  x2: 215.92,
  y2: 161.77,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 199.09,
  y1: 189.96,
  x2: 215.92,
  y2: 189.96,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 199.09,
  y1: 58.41,
  x2: 215.92,
  y2: 58.41,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 199.09,
  y1: 86.6,
  x2: 215.92,
  y2: 86.6,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 199.09,
  y1: 114.79,
  x2: 215.92,
  y2: 114.79,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 199.09,
  y1: 142.98,
  x2: 215.92,
  y2: 142.98,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 199.09,
  y1: 171.16,
  x2: 215.92,
  y2: 171.16,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}), /*#__PURE__*/React.createElement("line", {
  x1: 199.09,
  y1: 199.35,
  x2: 215.92,
  y2: 199.35,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10,
  opacity: 0.2
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "stock-graphs"
}, /*#__PURE__*/React.createElement("polyline", {
  points: "0.93 179.37 157.49 165.23 183.57 176.47 273.45 167.95 293.91 180.12 408.02 158.4 512.13 182.88 542.82 153.96 613.72 137.56 631.47 153.96 690.71 181.73 768.93 152.76",
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("polyline", {
  points: "768.93 118.38 637.83 106.54 611.75 117.78 521.86 109.26 501.4 121.43 387.3 99.7 283.18 124.18 252.5 95.27 170.72 95.27 163.84 95.27 104.61 123.03 0.93 84.65",
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("polyline", {
  points: "0.93 127.19 107.42 185.14 259.81 127.19 360.17 185.14 399.83 117.13 493.48 142.77 588.24 108.37 664.26 144.07 768.93 43.8",
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "stock-horizontal-lines"
}, /*#__PURE__*/React.createElement("line", {
  x1: 0.93,
  y1: 39.62,
  x2: 768.93,
  y2: 39.62,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.93,
  y1: 67.81,
  x2: 768.93,
  y2: 67.81,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.93,
  y1: 96,
  x2: 768.93,
  y2: 96,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.93,
  y1: 124.18,
  x2: 768.93,
  y2: 124.18,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.93,
  y1: 152.37,
  x2: 768.93,
  y2: 152.37,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.93,
  y1: 180.56,
  x2: 768.93,
  y2: 180.56,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.93,
  y1: 208.75,
  x2: 768.93,
  y2: 208.75,
  fill: "none",
  stroke: "#5356a5",
  strokeMiterlimit: 10
}));

function SvgAnimation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "stock-animation",
    viewBox: "0 0 769.87 209.25",
    width: 769.87,
    height: 209.25
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default "data:image/svg+xml;base64,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";
export { SvgAnimation as ReactComponent };